// Application Configuration Constants
// This file contains configuration settings for the application

// Firebase emulator connection methods
import { connectFirestoreEmulator } from 'firebase/firestore';
import { connectAuthEmulator } from 'firebase/auth';
import { connectFunctionsEmulator } from 'firebase/functions';
import { connectStorageEmulator } from 'firebase/storage';

export const CONFIG = {
  // Firebase Emulator Settings
  FIREBASE_EMULATOR: {
    ENABLED: false,  // Set to true to use Firebase emulator locally
    HOST: 'localhost',
    FIRESTORE_PORT: 8080,
    AUTH_PORT: 9099,
    FUNCTIONS_PORT: 5001,
    HOSTING_PORT: 5002,
    STORAGE_PORT: 9199,
    // Connection methods
    connectFirestore: connectFirestoreEmulator,
    connectAuth: connectAuthEmulator,
    connectFunctions: connectFunctionsEmulator,
    connectStorage: connectStorageEmulator
  },

  // Application Settings
  APP: {
    NAME: 'News Curator',
    VERSION: '1.0.0',
    MIN_ARTICLES: 3,
    MAX_ARTICLES: 5
  },

  // Authentication
  AUTH: {
    USERNAME: 'sunny',
    PASSWORD: 'ghoshna@123'
  },

  // Supported Languages for Translation
  LANGUAGES: {
    HINDI: 'hi',
    MARATHI: 'mr',
    GUJARATI: 'gu'
  },

  // Language Display Names
  LANGUAGE_NAMES: {
    'hi': 'Hindi',
    'mr': 'Marathi',
    'gu': 'Gujarati'
  },

};

// Helper function to check if emulator should be used
export function shouldUseEmulator() {
  return CONFIG.FIREBASE_EMULATOR.ENABLED &&
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' ||
      window.location.hostname === '127.0.0.1');
}

// Helper function to get emulator config
export function getEmulatorConfig() {
  if (!shouldUseEmulator()) return null;

  return {
    host: CONFIG.FIREBASE_EMULATOR.HOST,
    firestorePort: CONFIG.FIREBASE_EMULATOR.FIRESTORE_PORT,
    authPort: CONFIG.FIREBASE_EMULATOR.AUTH_PORT,
    functionsPort: CONFIG.FIREBASE_EMULATOR.FUNCTIONS_PORT,
    hostingPort: CONFIG.FIREBASE_EMULATOR.HOSTING_PORT,
    storagePort: CONFIG.FIREBASE_EMULATOR.STORAGE_PORT
  };
}

// Helper function to connect all Firebase services to emulator
export function connectToEmulators(db, auth, functions, storage) {
  if (!shouldUseEmulator()) return false;

  try {
    const config = CONFIG.FIREBASE_EMULATOR;
    
    // Connect Firestore
    if (db && config.connectFirestore) {
      config.connectFirestore(db, config.HOST, config.FIRESTORE_PORT);
      console.log(`Connected to Firestore emulator on ${config.HOST}:${config.FIRESTORE_PORT}`);
    }

    // Connect Auth
    if (auth && config.connectAuth) {
      config.connectAuth(auth, `http://${config.HOST}:${config.AUTH_PORT}`);
      console.log(`Connected to Auth emulator on http://${config.HOST}:${config.AUTH_PORT}`);
    }

    // Connect Functions
    if (functions && config.connectFunctions) {
      config.connectFunctions(functions, config.HOST, config.FUNCTIONS_PORT);
      console.log(`Connected to Functions emulator on ${config.HOST}:${config.FUNCTIONS_PORT}`);
    }

    // Connect Storage
    if (storage && config.connectStorage) {
      config.connectStorage(storage, config.HOST, config.STORAGE_PORT);
      console.log(`Connected to Storage emulator on ${config.HOST}:${config.STORAGE_PORT}`);
    }

    return true;
  } catch (error) {
    console.error('Failed to connect to Firebase emulators:', error);
    return false;
  }
}

// Export individual constants for convenience
export const {
  FIREBASE_EMULATOR,
  APP,
  AUTH,
  LANGUAGES,
  LANGUAGE_NAMES,
  API
} = CONFIG;
